import { motion } from 'framer-motion'
import { Shield, BarChart2, Zap, Brain, Activity } from 'lucide-react'
import { features } from '../../data'

export function HomeFeatures() {
  return (
    <section className="section-padding bg-gray-50">
      <div className="container-custom">
        <div className="text-center mb-16">
          <motion.h2
            initial={{ y: 30, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, ease: 'easeOut' }}
            className="text-3xl md:text-4xl font-bold mb-4"
          >
            核心功能
          </motion.h2>
          <motion.p
            initial={{ y: 30, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.2, ease: 'easeOut' }}
            className="text-lg text-gray-600 max-w-2xl mx-auto"
          >
            我们的供应链管理系统集成了多种先进功能，为学校食堂提供全方位的管理解决方案
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <motion.div
              key={feature.id}
              initial={{ y: 50, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1, ease: 'easeOut' }}
              whileHover={{ y: -5, transition: { duration: 0.3, ease: 'easeOut' } }}
              className="card p-8"
            >
              <div className="w-16 h-16 bg-primary-100 rounded-2xl flex items-center justify-center mb-6">
                {feature.icon === 'scan' && <Activity className="w-8 h-8 text-primary-500" />}
                {feature.icon === 'brain' && <Brain className="w-8 h-8 text-primary-500" />}
                {feature.icon === 'activity' && <Activity className="w-8 h-8 text-primary-500" />}
                {feature.icon === 'shield-check' && <Shield className="w-8 h-8 text-primary-500" />}
                {feature.icon === 'zap' && <Zap className="w-8 h-8 text-primary-500" />}
                {feature.icon === 'bar-chart-2' && <BarChart2 className="w-8 h-8 text-primary-500" />}
              </div>
              <h3 className="text-xl font-semibold mb-3">{feature.title}</h3>
              <p className="text-gray-600 mb-4">{feature.description}</p>
              {feature.details && (
                <ul className="space-y-2">
                  {feature.details.map((detail, i) => (
                    <li key={i} className="flex items-center space-x-2 text-sm text-gray-600">
                      <span className="w-1.5 h-1.5 bg-primary-500 rounded-full flex-shrink-0" />
                      <span>{detail}</span>
                    </li>
                  ))}
                </ul>
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  )
}
